import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDynamics365Component } from './simple-icons-dynamics365.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDynamics365Component ],
    exports:      [ SimpleIconsDynamics365Component ],
    bootstrap:    []
})
export class SimpleIconsDynamics365Module {}
